module.exports = __webpack_public_path__ + "static/13-e9f4fef38ffdb33a2d5304bf99a12df9.jpg";